import Vue from 'vue'
import Breadcrumbs from './Breadcrumbs.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(Breadcrumbs)
}).$mount('#vue_block_breadcrumbs')
